import { PathUtils } from "@adobe/aem-spa-page-model-manager";

export default class ModelManagerUtils {
  static getModelRootUrl() {
    // check if the URL path contains experience-fragment
    const pathName = window?.location?.pathname;

    // if (pathName && !pathName.includes("/content/aem-sites-react-spa-ssr")) {
    //   return pathName;
    // }

    return PathUtils.getModelUrl() || pathName;
  }

  static replaceLanguageInModelPath({ modelPath, languageCode }) {
    const languagePathRegex = /\/us\/[a-z]+/;
    return modelPath.replace(languagePathRegex, `/us/${languageCode}`);
  }
}
